import Axios from 'axios';

const TranscriptsAxiosInstance = Axios.create();

export default TranscriptsAxiosInstance;
